import React, { FC } from 'react';
import { BOXSCORE, isMotorizmus } from '../utils';
import { SrWidget } from './SrWidget';
import STATISTICS_TABS from './tabs';

export interface SrWidgetLmtStatisticsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
    sportId: string;
    tab: STATISTICS_TABS;
}

export const SrWidgetLmtStatistics: FC<SrWidgetLmtStatisticsProps> = ({ matchId, sportId, tab, ...props }) => {
    const widgetProps = {
        matchId: matchId,
        stageId: isMotorizmus(sportId) ? matchId : null,
        tabs: buildTabConfig(tab),
        scoreboard: 'disable',
        momentum: 'disable',
        tabsPosition: 'disable',
        collapseTo: 'disable',
        disableTrack: true,
        disablePitch: true,
        disableWidgetHeader: true,
        disableAds: true
    };
    return <SrWidget widgetName="match.lmtPlus" widgetProps={widgetProps} {...props} />;
};

// BR docs - https://widgets.sir.sportradar.com/docs/tutorial-example-lmt-tabs-reorder.html
const buildTabConfig = (tab: STATISTICS_TABS) => ({
    40: [tab],
    1: [tab],
    2: [tab],
    //musi tu byt tato debilnost, lebo inteligenti v betradare ... je mozne ze sa casom boxstore pokazi ked si to uvedomia...
    3: [tab === BOXSCORE ? 'boxScore' : tab],
    4: [tab],
    5: [tab],
    6: [tab],
    16: [tab],
    19: [tab],
    20: [tab],
    22: [tab],
    23: [tab],
    29: [tab],
    31: [tab],
    34: [tab]
});
